import React from 'react';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="bg-ink border-t border-concrete/10 py-10 px-6 md:px-10">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex flex-col gap-1">
          <span className="font-mono text-[0.85rem] font-bold tracking-[0.18em] uppercase text-concrete/60">
            Hvz<span className="text-coral/60">.photos</span>
          </span>
          <span className="font-mono text-[0.55rem] tracking-[0.25em] uppercase text-concrete/25">
            Galați, Romania
          </span>
        </div>

        <div className="flex items-center gap-8">
          <a href="#about" className="font-mono text-[0.62rem] font-bold tracking-[0.25em] uppercase text-concrete/40 hover:text-coral transition-colors">
            About
          </a>
          <a href="#work" className="font-mono text-[0.62rem] font-bold tracking-[0.25em] uppercase text-concrete/40 hover:text-coral transition-colors">
            Work
          </a>
          <a href="#contact" className="font-mono text-[0.62rem] font-bold tracking-[0.25em] uppercase text-concrete/40 hover:text-coral transition-colors">
            Contact
          </a>
        </div>

        <p className="font-mono text-[0.6rem] font-bold tracking-[0.2em] uppercase text-concrete/25">
          © {currentYear} Seferis Toni
        </p>
      </div>
    </footer>
  );
}